<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5237 30.6904C15.1489 30.0652 15.5 29.2174 15.5 28.3333C15.5 27.4493 15.1489 26.6014 14.5237 25.9763C13.8986 25.3512 13.0508 25 12.1667 25C11.2827 25 10.4348 25.3512 9.80968 25.9763C9.18456 26.6014 8.83337 27.4493 8.83337 28.3333C8.83337 29.2174 9.18456 30.0652 9.80968 30.6904C10.4348 31.3155 11.2827 31.6667 12.1667 31.6667C13.0508 31.6667 13.8986 31.3155 14.5237 30.6904Z"
      :stroke="color"
    />
    <path
      d="M31.1904 30.6904C31.8155 30.0652 32.1667 29.2174 32.1667 28.3333C32.1667 27.4493 31.8155 26.6014 31.1904 25.9763C30.5653 25.3512 29.7174 25 28.8334 25C27.9493 25 27.1015 25.3512 26.4764 25.9763C25.8512 26.6014 25.5 27.4493 25.5 28.3333C25.5 29.2174 25.8512 30.0652 26.4764 30.6904C27.1015 31.3155 27.9493 31.6667 28.8334 31.6667C29.7174 31.6667 30.5653 31.3155 31.1904 30.6904Z"
      :stroke="color"
    />
    <path
      d="M22.1667 26.6667V10C22.1667 9.55801 21.9911 9.13409 21.6785 8.82153C21.3659 8.50897 20.942 8.33337 20.5 8.33337H7.16667C6.72464 8.33337 6.30072 8.50897 5.98816 8.82153C5.67559 9.13409 5.5 9.55801 5.5 10V26.6667C5.5 27.1087 5.67559 27.5327 5.98816 27.8452C6.30072 28.1578 6.72464 28.3334 7.16667 28.3334H8.83333M22.1667 26.6667C22.1667 27.1087 21.9911 27.5327 21.6785 27.8452C21.3659 28.1578 20.942 28.3334 20.5 28.3334H15.5M22.1667 26.6667V13.3334C22.1667 12.8913 22.3423 12.4674 22.6548 12.1549C22.9674 11.8423 23.3913 11.6667 23.8333 11.6667H28.1433C28.5853 11.6668 29.0092 11.8425 29.3217 12.155L35.0117 17.845C35.3242 18.1575 35.4999 18.5814 35.5 19.0234V26.6667C35.5 27.1087 35.3244 27.5327 35.0118 27.8452C34.6993 28.1578 34.2754 28.3334 33.8333 28.3334H32.1667M22.1667 26.6667C22.1667 27.1087 22.3423 27.5327 22.6548 27.8452C22.9674 28.1578 23.3913 28.3334 23.8333 28.3334H25.5M8.83333 28.3334C8.83333 29.2174 9.18452 30.0653 9.80964 30.6904C10.4348 31.3155 11.2826 31.6667 12.1667 31.6667C13.0507 31.6667 13.8986 31.3155 14.5237 30.6904C15.1488 30.0653 15.5 29.2174 15.5 28.3334M8.83333 28.3334C8.83333 27.4493 9.18452 26.6015 9.80964 25.9764C10.4348 25.3512 11.2826 25 12.1667 25C13.0507 25 13.8986 25.3512 14.5237 25.9764C15.1488 26.6015 15.5 27.4493 15.5 28.3334M32.1667 28.3334C32.1667 29.2174 31.8155 30.0653 31.1904 30.6904C30.5652 31.3155 29.7174 31.6667 28.8333 31.6667C27.9493 31.6667 27.1014 31.3155 26.4763 30.6904C25.8512 30.0653 25.5 29.2174 25.5 28.3334M32.1667 28.3334C32.1667 27.4493 31.8155 26.6015 31.1904 25.9764C30.5652 25.3512 29.7174 25 28.8333 25C27.9493 25 27.1014 25.3512 26.4763 25.9764C25.8512 26.6015 25.5 27.4493 25.5 28.3334"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script>
export default {
  name: 'IconTruck',
  props: {
    color: {
      type: String,
      default: '#000',
    },
    width: {
      type: [String, Number],
      default: 41,
    },
    height: {
      type: [String, Number],
      default: 40,
    },
  },
}
</script>
